module.exports = __webpack_public_path__ + "img/power-level-3.658f836e.png";